module.exports = __webpack_public_path__ + "static/media/DSC04778.bbd6d15f.JPG";